import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SugargooSpreadsheetGuide from "../pages/article/page";
import ArticlePage from "../pages/articles/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <SugargooSpreadsheetGuide />,
  },
  {
    path: "/articles/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;